import clsx from "clsx";
import React, { type FC, type ReactNode } from "react";

type GroupProps = {
    className?: string;
    children?: ReactNode;
};

export const Group: FC<GroupProps> = (props) => {
    return (
        <div
            className={clsx(
                "w-full rounded-[12px] bg-bg_0 overflow-hidden px-[12px] py-[0px]",
                props.className
            )}
        >
            {props.children}
        </div>
    );
};
